/**
 * Soft notice surface tones shared by Alert (inline host) and Toast (overlay
 * host). Ramp `*-25` wash + accent border; hosts add their own icon selectors
 * and layout. See Color system notes in index.css.
 */
export const noticeSurface = {
  default: "bg-card text-card-foreground",
  success: "border-success bg-success-25",
  warning: "border-warning bg-warning-25",
  destructive: "border-destructive bg-destructive-25",
} as const
